import { parseDataTypes } from '@frx/frx-services';
import { useGetInfo, useLowercaseQueryString } from '@frx/frx-react-context';
import { useAppProvider } from '../context';
import {
  getSessionFormData,
  SessionFormData,
  setPrice,
  setTransaction,
} from '../utils';

export type Transaction = {
  transaction: {
    campaign: string;
    amount: string;
    cardType: string;
    firstName: string;
    paymentMethodCard: string;
    transactionID: string;
    profile: {
      email: string;
      address: {
        state: string;
        zip: string;
      };
    };
  };
};

type UseDonationInfoResponse = {
  data: Transaction;
};

export const useDonationInfo = (): UseDonationInfoResponse => {
  const {
    data: { token },
  } = useAppProvider();
  const {
    queryStrings: { fr_id },
  } = useLowercaseQueryString();

  const content = {
    transaction: {
      campaign: '[[S120:dc:donationFormName]]',
      firstName: '[[S120:dc:donorFirstName]]',
      transactionID: '[[S120:dc:transactionID]]',
      paymentMethodCard: '[[S120:dc:creditCardDonation]]',
      cardType: '[[S120:dc:creditCardType]]',
      amount: '[[S120:dc:paymentAmount]]',
      profile: {
        email: '[[S120:dc:email]]',
        address: {
          state: '[[S120:dc:donorState]]',
          zip: '[[S120:dc:donorZip]]',
        },
      },
    },
  };

  const { data: transaction } = useGetInfo(
    { content },
    `donationInfo, ${fr_id}`,
    {
      enabled: !!token,
      select: (data: any) => parseDataTypes(JSON.parse(data?.preview || '{}')),
      onSuccess: (response: any) => {
        const transactionID = response?.transaction?.transactionID;
        const formData = (getSessionFormData() || {
          paymentSchedule: 'one time',
        }) as SessionFormData;

        setTransaction({
          profile: {
            email: formData?.donorEmail,
            address: {
              state: formData?.state,
              zip: formData?.postCode,
            },
          },
          item: [
            {
              attributes: {
                frequencyType: formData?.paymentSchedule?.toLowerCase(),
                price: setPrice(),
                quantity: 1,
              },
            },
          ],
          transactionID,
          paymentType: response?.transaction?.paymentMethodCard
            ? 'credit-card'
            : 'paypal',
        });

        if ((window as any).stjude.digitalData.transaction) {
          (window as any)?._satellite?.track('donationCompleted');
        }
      },
    }
  );

  return { data: transaction as unknown as Transaction };
};
